import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileService, FileUploadOptions, SignUrlDataType } from '@schoolbelle/api/file';

export interface SearchGroupInfo {
  group_id: string;
  group_name: string;
  school_name: string;
  face_admin: string;
  type: string;
  address: string;
  location?: { lat: number; lon: number };
}

@Injectable()
export class StaffFileService extends FileService {
  protected override getUrl(
    fileInfo: { name: string; type: string; size: number },
    opts: FileUploadOptions,
    authorizationToken: string,
  ) {
    let obs = this.http.post(
      this.serverHost + '/staff/file/sign/upload',
      {
        sign_for: 'upload',
        name: fileInfo.name,
        type: fileInfo.type,
        size: fileInfo.size,
        selector_id: opts.selector_id,
        process: opts.process,
        test: opts.test,
      },
      {
        headers: { Authorization: `Bearer ${authorizationToken}` },
      },
    ) as Observable<SignUrlDataType>;
    return obs;
  }
}
